import * as React from 'react';

// styles
const pageStyles = {
  color: '#383838',
  padding: '96px',
  fontFamily: '-apple-system, Roboto, sans-serif, serif',
  display: 'none',
};

// markup
const Index = (): JSX.Element => {
  return <main style={pageStyles}>Intentionally Blank</main>;
};

export default Index;
